import { GenericField, InputProps } from "../Fields/GenericField";
import {
  DATE_TIME_LOCAL_FORMAT,
  DATE_TIME_TZ_FORMAT,
  toDateTimeString,
} from "@/lib/Formatters/toDateTimeString";
import { useField } from "formik";
import dayjs from "dayjs";
import { ComponentProps, useRef } from "react";
import { Input } from "@/components/catalyst/input";

export type TextInputProps = InputProps & {
  inputProps?: ComponentProps<"input">;
  type?: "email" | "datetime-local" | "datetime" | "text" | "time" | "password";
  onChange?: (val: string | null) => void;
};

export function TextInput({
  inputProps,
  onChange,
  type = "text",
  autoFocus,
  ...props
}: TextInputProps) {
  const { emptyValue = "" } = props;
  const [field, meta, { setValue }] = useField(props.name);
  const showError = !!meta.error && meta.touched;
  const hasChanged = useRef(false);

  let value: string | null | number;
  switch (type) {
    case "datetime-local":
      value = field.value
        ? dayjs(field.value).local().format(DATE_TIME_LOCAL_FORMAT)
        : "";
      break;
    default:
      value = field.value ?? emptyValue;
      break;
  }

  return (
    <GenericField viewNode={<span>{value || "--"}</span>} {...props}>
      <Input
        {...field}
        {...inputProps}
        type={type}
        autoFocus={autoFocus}
        value={value as string}
        invalid={showError}
        onBlur={(e) => {
          if (hasChanged.current) {
            field.onBlur(e);
          }
          hasChanged.current = false;
        }}
        onChange={async (event) => {
          hasChanged.current = true;
          let fieldValue: string | null;

          if (type === "datetime") {
            if (event.target.value === "") {
              fieldValue = null;
            } else {
              fieldValue = toDateTimeString(event.target.value);
            }
          } else if (type === "datetime-local") {
            if (event.target.value === "") {
              fieldValue = null;
            } else {
              fieldValue = dayjs(event.target.value)
                .utc()
                .format(DATE_TIME_TZ_FORMAT);
            }
          } else {
            fieldValue = event.target.value ? event.target.value : emptyValue;
          }

          await setValue(fieldValue);
          onChange?.(fieldValue);
        }}
      />
    </GenericField>
  );
}
